import * as React from "react";
import { ElementsParallax } from "components";
import SendForm from "./SendForm";
import Model from "hooks/Model";

function SendScreen() {
  React.useEffect(() => {
    Model.setData("layoutConfig", { withBg: true });
  }, []);
  return (
    <>
      <ElementsParallax variant="leftBg" />
      <ElementsParallax variant="rightBg" />
      <SendForm />
    </>
  );
}

export default SendScreen;
